// extracted by mini-css-extract-plugin
export default {"products":"tt-z","card":"ut-z","oosMessaging":"vt-z"};